import React, { useState } from 'react';
import './MobileGrid.scss';
import { Collapse, Button } from 'react-bootstrap';

const FilterPanel = props => {
  const [showPanel, setShowPanel] = useState(false);

  const filterComponents = [];
  const storeFilter = f => {
    filterComponents.push(f);
    //console.log(filterComponents.lenght);
  };
  const renderFilter = ({ key, name, filterRenderer }) => {
    const FilterRenderer = filterRenderer;

    const id = `label${key}`;
    const filterKey = `filter_${key}`;
    return (
      <div className="form-group" key={filterKey}>
        <label htmlFor={id} className="col-md-4 control-label">
          {name}
        </label>
        <div className="col-md-8 control-input">
          <FilterRenderer
            id={id}
            column={{ key: key }}
            getValidFilterValues={props.getValidFilterValues}
            onChange={props.onChange}
            ref={storeFilter}
          />
        </div>
      </div>
    );
  };

  const clearFilters = () => {
    filterComponents.forEach(c => {
      if (
        c.resetComponentState &&
        typeof c.resetComponentState === 'function'
      ) {
        c.resetComponentState();
      }
    });
    props.onClearFilters();
  };

  const render = () => {
    const filters = props.columns.filter(c => c.filterRenderer);

    if (filters.length === 0) return null;
    return (
      // <Collapsible trigger="Filters">
      <React.Fragment>
        <div className="button-group">
          <Button
            onClick={() => setShowPanel(!showPanel)}
            bsSize="small"
            bsStyle="basic"
            aria-expanded={showPanel}
          >
            {showPanel ? 'Hide Row Filters' : 'Show Row Filters'}
          </Button>
          {props.filters && props.filters.length > 0 ? (
            <Button onClick={clearFilters} bsSize="small" bsStyle="basic">
              Clear Filters
            </Button>
          ) : null}
        </div>
        <Collapse in={showPanel} className="filter-panel">
          <form className="form-horizontal border">
            {filters.map(f => renderFilter(f))}
          </form>
        </Collapse>
      </React.Fragment>
    );
  };
  return render();
};

export default FilterPanel;
